"use client";

import type React from "react";
import { SidebarHeader } from "./ui/sidebar";

type SubView = "new" | "in_process" | "agent";

export function SidebarSubViewBar({
  subView,
  setSubView,
  newCount,
  inProcessCount,
  agentCount,
  agentLabel,
  t,
}: {
  subView: SubView;
  setSubView: (v: SubView) => void;
  newCount: number;
  inProcessCount: number;
  agentCount: number;
  agentLabel?: string | number;
  t: (key: string) => string;
}) {
  return (
    <SidebarHeader className="p-2">
      <div className="flex w-full items-center rounded-lg border border-[#E5E7EC] bg-white p-1">
        <div className="flex basis-2/3 items-center flex-nowrap gap-0">
          <button
            onClick={() => setSubView("new")}
            className={
              "h-8 rounded-md px-0.5 text-xs font-medium transition text-[#252A32] whitespace-nowrap flex-shrink-0 border border-transparent hover:bg-[#F6F7F9] " +
              (subView === "new"
                ? "bg-[#F6F7F9] shadow-sm border !border-[#105BDB]"
                : "")
            }
          >
            <span className="inline-flex items-center gap-1">
              <span className="inline-flex h-6 min-w-[1.5rem] items-center justify-center rounded-full bg-[#105BDB] px-2 text-[10px] leading-6 text-white">
                {newCount}
              </span>
              <span>{t("new") || "Nuevos"}</span>
            </span>
          </button>

          <button
            onClick={() => setSubView("in_process")}
            className={
              "h-8 rounded-md px-0.5 text-xs font-medium transition text-[#252A32] whitespace-nowrap flex-shrink-0 border border-transparent hover:bg-[#F6F7F9] " +
              (subView === "in_process"
                ? "bg-[#F6F7F9] shadow-sm border !border-[#105BDB]"
                : "")
            }
          >
            <span className="inline-flex items-center gap-1">
              <span className="inline-flex h-6 min-w-[1.5rem] items-center justify-center rounded-full bg-[#105BDB] px-2 text-[10px] leading-6 text-white">
                {inProcessCount}
              </span>
              <span>{t("in_process") || "En proceso"}</span>
            </span>
          </button>
        </div>

        <span className="mx-0 h-6 w-px flex-grow bg-[#E5E7EC]" />

        <div className="flex basis-1/3 items-center justify-end">
          <button
            onClick={() => setSubView("agent")}
            className={
              "h-8 rounded-md px-0.5 text-xs font-medium transition text-[#252A32] whitespace-nowrap flex-shrink-0 border border-transparent hover:bg-[#F6F7F9] " +
              (subView === "agent"
                ? "bg-[#F6F7F9] shadow-sm border !border-[#105BDB]"
                : "")
            }
          >
            <span className="inline-flex items-center gap-1">
              <span className="inline-flex h-6 min-w-[1.5rem] items-center justify-center rounded-full bg-[#105BDB] px-2 text-[10px] leading-6 text-white">
                {agentCount}
              </span>
              <span>{t("agent") || "Agente"}</span>
              {typeof agentLabel !== "undefined" && agentLabel !== null && (
                <span>{agentLabel}</span>
              )}
            </span>
          </button>
        </div>
      </div>
    </SidebarHeader>
  );
}
